<template>
  <div id='bd-notice-aside'>
    <div class="notice-search">
      <el-button style="float: left;" size="mini" icon="el-icon-plus" circle @click="showCreateNoticeDialog()"></el-button>
      <el-input style="width: 70%;" size="mini" :placeholder="searchTip" suffix-icon="el-icon-search" v-model="search" clearable></el-input>
      <el-button style="float: right;" size="mini" icon="el-icon-refresh" circle @click="refreshData()"></el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <li v-for="notice in filterdNotices" :key="notice.nid" class="list-item"
        :class="{ ' active': notice.nid === userCurrentNotice.nid }"
        @click="selectNotice(notice)">
        <div class="list-right">
          <div class="top">
            <span class="nickname">{{ notice.title }}
              <!-- <span style="color: red;">{{ isUrgent(notice) }}</span> -->
            </span>
            <span class="timestamp">
              {{ notice.createdAt | time }}
            </span>
          </div>
          <div class="bottom">
              <span class="content">{{ notice.content }}</span>
            </div>
        </div>
      </li>
      <el-empty v-if="filterdNotices.length === 0" description="空"></el-empty>
    </div>
    <el-dialog v-dialogDrag
      :title="createNoticeTip"
      :visible.sync="createNoticeDialogVisible"
      width="550"
      center>
      <el-form :model="notice" :rules="rules" label-width="90px">
        <!-- FIXME: 存在bug，不管前端选择是否紧急，数据库均为0 -->
        <!-- <el-form-item label="类型">
          <el-radio-group v-model="notice.urgent">
            <el-radio :label="false">普通</el-radio>
            <el-radio :label="true">重要</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="titleTip">
          <el-input v-model="notice.title" :placeholder="titleTip"></el-input>
        </el-form-item>
        <el-form-item :label="contentTip">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="notice.content"></el-input>
        </el-form-item>
        <el-form-item :label="attachmentsTip">
          <!-- TODO: 附件 -->
          <el-upload class='bd-upload-file'
            :on-preview='handlePreview'
            :on-remove='handleRemove'
            :before-remove='beforeRemove'
            multiple
            :limit="6"
            :on-exceed='handleExceed'
            :file-list='uploadedFileList'
            :data='upload_data'
            :name='upload_name'
            :action='uploadFileServerUrl'
            :on-success='handleFileUploadSuccess'
            :before-upload='beforeFileUpload'>
              <el-button size="small" type="primary">{{ $t('upload') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('noExceed6file') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="noticeTypeTip">
            <el-radio-group v-model="notice.type">
              <el-radio label="workgroup">{{ $t('workGroup') }}</el-radio>
              <el-radio label="appointed">{{ $t('appointed') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="notice.type === 'workgroup'" :label="noticeWorkGroupTip">
            <el-checkbox-group v-model="notice.wids">
              <el-checkbox v-for="workgroup in workgroupOptions" :label="workgroup.value" :key="workgroup.value">{{ workgroup.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="notice.type === 'appointed'" :label="noticeAgentTip">
            <el-checkbox-group v-model="notice.uids">
              <el-checkbox v-for="agent in agentOptions" :label="agent.value" :key="agent.value">{{ agent.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        <!-- <el-form-item label="失效时间">
          <el-input v-model="notice.title" placeholder="失效时间"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="createNoticeDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="doSendNotice">{{ $t('ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as https from '@/apis/http'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-notice-aside',
  data () {
    return {
      isLoading: true,
      search: '',
      createNoticeDialogVisible: false,
      //
      notice: {
        // id: 0,
        // nid: '',
        urgent: false,
        title: '',
        content: '',
        attachments: [],
        type: 'workgroup',
        wids: [],
        uids: []
      },
      workgroupOptions: [],
      agentOptions: [],
      pageParam: {
        page: 0,
        size: 100
      },
      //
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      // 上传图片相关参数
      upload_headers: {
        'X-CSRF-TOKEN': '',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'Bearer '
      },
      upload_data: {
        file_name: 'test.png',
        username: ''
      },
      upload_name: 'file',
      // 接收图片服务器地址
      uploadFileServerUrl: constants.UPLOAD_FILE_URL,
      // 上传图片结果集, 格式：{name: '', url: ''}
      uploadedFileList: [],
      uploadFileType: ''
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentNotice', 'userContacts', 'userNotices' ]),
    searchTip () {
      return this.$t('search')
    },
    createNoticeTip () {
      return this.$t('createNotice')
    },
    titleTip () {
      return this.$t('title')
    },
    contentTip () {
      return this.$t('content')
    },
    attachmentsTip () {
      return this.$t('attachments')
    },
    noticeTypeTip () {
      return this.$t('noticeType')
    },
    noticeWorkGroupTip () {
      return this.$t('noticeWorkGroup')
    },
    noticeAgentTip () {
      return this.$t('noticeAgent')
    },
    filterdNotices () {
      return this.userNotices.filter(notice => {
        return notice.title.includes(this.search)
      })
    }
  },
  methods: {
    //
    ...mapActions('mqtt', [ 'sendNoticeProtobuf' ]),
    ...mapActions([ 'updateCurrentNotice', 'getContacts', 'getNotices' ]),
    refreshData () {
      console.log('refreshData')
      this.myNotices()
    },
    isUrgent (notice) {
      return notice.urgent ? '[重要]' : ''
    },
    showCreateNoticeDialog () {
      //
      this.createNoticeDialogVisible = true
    },
    doSendNotice () {
      // TODO: 判断长链接是否断开，如果断开，则调用rest接口发送通知；否则，调用长链接接口
      this.notice.attachments = []
      for (let i = 0; i < this.uploadedFileList.length; i++) {
        const element = this.uploadedFileList[i]
        this.notice.attachments.push(element.url)
      }
      let contentString = JSON.stringify(this.notice)
      // console.log('notice:', this.notice, contentString)
      //
      if (this.notice.type === 'workgroup') {
        // 通知技能组
        for (let i = 0; i < this.notice.wids.length; i++) {
          const wid = this.notice.wids[i]
          let payload = { topic: wid, content: contentString, type: constants.NOTICE_TYPE_NORMAL }
          this.sendNoticeProtobuf(payload)
        }
      } else {
        // 通知每个客服
        for (let i = 0; i < this.notice.uids.length; i++) {
          const uid = this.notice.uids[i]
          let payload = { topic: uid, content: contentString, type: constants.NOTICE_TYPE_NORMAL }
          this.sendNoticeProtobuf(payload)
        }
      }
      this.createNoticeDialogVisible = false
    },
    /**
     * 上传图片相关函数
     */
    handleRemove (file, uploadedFileList) {
      console.log(file, uploadedFileList)
      // 删除
      for (var i = 0; i < this.uploadedFileList.length; i++) {
        if (this.uploadedFileList[i].name === file.name) {
          this.uploadedFileList.splice(i, 1)
        }
      }
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, uploadedFileList) {
      this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + uploadedFileList.length} 个文件`)
    },
    beforeRemove (file, uploadedFileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    beforeFileUpload (file) {
      // file.name包含文件后缀
      // TODO: 给文件名增加前缀，避免重复
      this.upload_data.file_name = file.name
      // 文件大小控制在2m之内
      this.uploadFileType = file.type
      const isLt10M = file.size / 1024 / 1024 < 10
      return isLt10M
    },
    handleFileUploadSuccess (result, file) {
      // console.log('upload file success result:', result, ' file:', file)
      if (result.status_code === 200) {
        let url = result.data
        this.uploadedFileList.push({ name: file.name, url: url })
      } else {
        this.$message.error('上传文件错误，请稍后重试...')
      }
    },
    selectNotice (notice) {
      // console.log('select notice: ', notice)
      this.updateCurrentNotice(notice)
    },
    getAllWorkGroups () {
      if (this.workgroupOptions.length > 0) {
        return
      }
      //
      https.getAllWorkGroups(response => {
        // console.log('all workgroups: ', response)
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i]
          this.workgroupOptions.push({ value: element.wid, label: element.nickname })
        }
      }, error => {
        console.log(error)
      })
    },
    handleSuccess(contacts) {
      for (let i = 0; i < contacts.length; i++) {
        const element = contacts[i];
        this.agentOptions.push({
          value: element.uid,
          label: element.realName,
        });
      }
    },
    handleFailed(error) {
      console.log(error);
    },
    getAllContacts () {
      if (this.agentOptions.length > 0) {
        return
      }
      if (this.userContacts.length > 0) {
        for (let i = 0; i < this.userContacts.length; i++) {
          const element = this.userContacts[i];
          this.agentOptions.push({
            value: element.uid,
            label: element.realName,
          });
        }
        return
      }
      //
      let payload = { successcb: this.handleSuccess, failedcb: this.handleError }
      this.getContacts(payload)
    },
    myNotices () {
      // 首先清空
      let payload = { page: this.pageParam.page, size: this.pageParam.size }
      this.getNotices(payload)
    }
  },
  created () {
    //
  },
  mounted () {
    this.refreshData()
    this.getAllWorkGroups()
    this.getAllContacts()
    // 监听创建通知
    bus.$on(constants.EVENT_BUS_CREATE_NOTICE, message => {
      this.createNoticeDialogVisible = true
    })
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (value) {
      if (typeof value === 'string') {
        return moment(value).format('MM-DD HH:mm')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
#bd-notice-aside {
  width: 100%;
  height: 100%;
  float: left;
}
.notice-search {
  padding: 12px 12px 12px 12px;
}
.list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  height: 50px;
}
.list-item:hover {
  background-color: rgb(220,220,220)
}
.active {
  background-color:darkkhaki
}
.list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
li {
  list-style: none;
}
.list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
.list-right {
  margin-left: 12px;
}
.list-right .top {
  margin-top: 2px;
  text-align: left;
}
span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
span.timestamp {
  float: right;
  color:gray;
  font-size: 12px;
  vertical-align: top;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .bottom {
  width: 0%;
  text-align: left;
}
.list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
.list-right .bottom .content{
  font-size: 12px;
  width: 150px;
  height: 100%;
  color: gray;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .unreadCount {
    margin-top: 4px;
    float: right;
    font-size: 10px;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius:5px;
    color: white;
    background-color: red;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-form {
  margin-bottom: 0px;
}
</style>
